import * as stylex from '@stylexjs/stylex'
import { type StyleXStyles } from '@stylexjs/stylex'
import { type ReactNode } from 'react'
import { ButtonBase, type ButtonBaseProps } from '../ButtonBase/ButtonBase'
import { colors } from '../tokens/colors.stylex'
import { elevationBottom } from '../tokens/elevation.stylex'
import { zIndex } from '../tokens/zIndex.stylex'

const sizeVariants = stylex.create({
  medium: {
    height: 44,
    width: 44,
  },
  large: {
    height: 56,
    width: 56,
  },
})

const baseStyles = stylex.create({
  root: {
    borderRadius: '50%',
    overflow: 'hidden',
    alignItems: 'center',
    backgroundColor: colors.white,
    boxShadow: elevationBottom.elevation4,
    display: 'inline-flex',
    justifyContent: 'center',
    zIndex: zIndex.fab,
  },
})

export type ButtonSize = 'medium' | 'large'

export interface FloatingActionButtonProps extends ButtonBaseProps {
  /**
   * 按鈕尺寸
   * @default 'medium'
   */
  size?: ButtonSize
  /** 按鈕內容（通常為圖示） */
  children?: ReactNode
  /** 根元素的自訂樣式 */
  rootStyle?: StyleXStyles
}

/**
 * FloatingActionButton (FAB) 浮動操作按鈕，固定圓形外觀並帶有陰影。
 * 常用於頁面主要操作（如新增、捲動至頂部等）。
 */
export const FloatingActionButton = (props: FloatingActionButtonProps) => {
  const { size = 'medium', children, rootStyle, ...rest } = props

  return (
    <ButtonBase
      rootStyle={[
        baseStyles.root,
        sizeVariants[size],
        rootStyle,
      ]}
      {...rest}
    >
      {children}
    </ButtonBase>
  )
}
